import LearnVisualFrame from "./LearnVisualFrame";
import p from "./visualPalette";

export default function ValuationBridgeVisual({ title, takeaway, caption, data = {} }) {
  const startLabel = data.startLabel || "Market Capitalization";
  const startValue = data.startValue || "$500M";
  const steps = data.steps || [
    { label: "+ Debt", value: "$100M" },
    { label: "- Cash", value: "$50M" },
  ];
  const resultLabel = data.resultLabel || "Enterprise Value";
  const resultValue = data.resultValue || "$550M";

  return (
    <LearnVisualFrame title={title} takeaway={takeaway} caption={caption}>
      <svg
        viewBox="0 0 760 380"
        role="img"
        aria-label={`${startLabel} of ${startValue}, plus debt and minus cash, equals ${resultLabel} of ${resultValue}.`}
      >
        <rect x="255" y="24" width="250" height="76" rx="8" fill={p.surface} stroke={p.line} />
        <text x="380" y="55" textAnchor="middle" fontSize="14" fontWeight="850" fill={p.muted}>
          {startLabel}
        </text>
        <text x="380" y="83" textAnchor="middle" fontSize="25" fontWeight="900" fill={p.ink}>
          {startValue}
        </text>
        <text x="380" y="118" textAnchor="middle" fontSize="12" fontWeight="850" fill={p.muted}>
          Equity value
        </text>

        {steps.map((step, index) => {
          const y = 152 + index * 54;
          return (
            <g key={`${step.label}-${step.value}`}>
              <line x1="380" y1={index === 0 ? 126 : 180} x2="380" y2={y - 12} stroke={p.line} strokeWidth="2" />
              <rect x="288" y={y - 8} width="184" height="36" rx="18" fill={index === 0 ? p.goldWash : "#fff"} stroke={p.softLine} />
              <text x="380" y={y + 15} textAnchor="middle" fontSize="14" fontWeight="850" fill={p.ink}>
                {step.label} {step.value}
              </text>
            </g>
          );
        })}

        <line x1="380" y1="234" x2="380" y2="258" stroke={p.gold} strokeWidth="3" />
        <path d="M380 258 l-8 -11 h16 z" fill={p.gold} />
        <rect x="240" y="268" width="280" height="76" rx="8" fill={p.goldWash} stroke={p.gold} />
        <text x="380" y="299" textAnchor="middle" fontSize="14" fontWeight="850" fill={p.muted}>
          {resultLabel}
        </text>
        <text x="380" y="326" textAnchor="middle" fontSize="26" fontWeight="900" fill={p.ink}>
          {resultValue}
        </text>
        <text x="380" y="364" textAnchor="middle" fontSize="12" fontWeight="850" fill={p.muted}>
          Whole-business value
        </text>
      </svg>
    </LearnVisualFrame>
  );
}
